import React, { PropsWithChildren, ReactNode } from "react";

import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

interface RendererOption {
  value: any;
  renderer: ReactNode;
}

export interface RendererPickerProps extends PropsWithChildren<any> {
  orientation: "vertical" | "horizontal";
  options: RendererOption[];
  value: string;
  onChange: (selectedValue: string) => void;
}

export function RendererPicker(props: RendererPickerProps) {
  const { orientation, options, value, onChange } = props;

  return (
    <ToggleButtonGroup
      exclusive
      orientation={orientation}
      value={value}
      onChange={(evt, selectedValue) => onChange(selectedValue)}
    >
      {options.map((opt, index) => {
        return (
          <ToggleButton key={index} value={opt.value}>
            {opt.renderer}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}
